import { APP_COUNTRY } from 'config';
import { EsBettingWarningBanner } from './components/es-betting-warning-banner';
import { FrBettingWarningBanner } from './components/fr-betting-warning-banner';
import { useIsWarningBannerHidden } from './hooks/use-is-warning-banner-hidden';

/*------------------------------types------------------------------*/

type BettingWarningBannerProps = {
  isSticky?: boolean;
};

/*------------------------------component------------------------------*/

function BettingWarningBanner({ isSticky }: BettingWarningBannerProps) {
  const isWarningBannerHidden = useIsWarningBannerHidden();

  if (isWarningBannerHidden) return null;

  if (APP_COUNTRY === 'es')
    return <EsBettingWarningBanner isSticky={isSticky} />;

  return <FrBettingWarningBanner isSticky={isSticky} />;
}

export { BettingWarningBanner };
